/**
 * CUSTOM SLIDER - NO-POSTMESSAGE FACADE VERSION
 */

if (!customElements.get('custom-slider')) {
  customElements.define('custom-slider', class CustomSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = null;
      this.isMoving = false;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      if (document.readyState === 'complete') {
        this._setup();
      } else {
        window.addEventListener('load', () => this._setup());
      }
    }

    _setup() {
      this.desktopItems = parseInt(this.dataset.items) || 3; 
      this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1.2;
      this.gap = parseInt(this.dataset.gap) || 24;
      this.loop = this.dataset.loop === 'true';

      this.track = this.querySelector(`.custom-swiper-${this.sectionId}`);
      this.slides = this.querySelectorAll('.swiper-slide');
      
      if (!this.track || this.slides.length === 0) return;

      this._initSlider();
      this._setupVideoHandlers();
    }

    _initSlider() {
      if (this.sliderInstance) return;

      const prevEl = this.querySelector(`#swiper-prev-${this.sectionId}`);
      const nextEl = this.querySelector(`#swiper-next-${this.sectionId}`);
      const paginationEl = this.querySelector(`#swiper-pag-${this.sectionId}`);

      // Impostiamo valori numerici certi
      const gap = parseInt(this.dataset.gap) || 24;

      this.sliderInstance = new Swiper(this.track, {
        // Di base (Mobile)
        slidesPerView: parseFloat(this.dataset.mobileItems) || 1.2,
        spaceBetween: 16,
        loop: false,
        watchOverflow: true,
        grabCursor: true,

        navigation: { 
          nextEl: nextEl, 
          prevEl: prevEl 
        },
        pagination: paginationEl ? { 
          el: paginationEl, 
          type: 'progressbar' 
        } : false,

        breakpoints: {
          // Tablet (>= 768px)
          768: {
            slidesPerView: parseInt(this.dataset.tabletItems) || 2,
            spaceBetween: gap
          },
          // Desktop (>= 1024px) -> FORZIAMO 3 SLIDE PERFETTE
          1024: {
            slidesPerView: 3,
            spaceBetween: gap
          }
        }
      });

      // Forziamo il ricalcolo delle dimensioni dopo che il DOM è del tutto renderizzato
      setTimeout(() => {
        if (this.sliderInstance) {
          this.sliderInstance.update();
        }
      }, 100);
    }

    _setupVideoHandlers() {
      const handlePlay = (e) => {
        const facade = e.target.closest('.cvb-video-facade');
        if (!facade || this.isMoving) return;

        e.preventDefault();
        const container = facade.closest('.cvb-media-video');
        if (!container) return;

        const videoId = container.dataset.videoId;
        const target = container.querySelector('.cvb-iframe-target');

        // Se l'iframe non è presente, lo creiamo ed eliminiamo la necessità di postMessage
        if (videoId && target) {
          this._resetAllVideos(); // Spegne altri video attivi

          target.innerHTML = `
            <iframe
              src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0"
              title="YouTube Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          `;
          container.classList.add('video-active');
        }
      };

      this.addEventListener('click', handlePlay);
      this.addEventListener('touchend', handlePlay);
    }

    // Al cambio slide distrugge gli iframe attivi fermando l'audio senza postMessage
    _resetAllVideos() {
      this.querySelectorAll('.cvb-media-video.video-active').forEach(container => {
        container.classList.remove('video-active');
        const target = container.querySelector('.cvb-iframe-target');
        if (target) {
          target.innerHTML = ''; // Rimuove l'iframe e stoppa il video al 100%
        }
      });
    }

    _destroySlider() {
      if (this.sliderInstance) {
        this.sliderInstance.destroy(true, true);
        this.sliderInstance = null;
      }
    }
  });
}